import type { CSSObject } from '@emotion/react'
import { Color, Size, Spacing, Typography } from '@opallabs/gem'

const button: CSSObject = {
  backgroundColor: Color.light.Surface.A200,
  ...Typography.T500,
  inlineSize: Spacing.M * 13.0625,
  blockSize: Spacing.L * 1.5,
  borderRadius: Size.Rounding,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBlockStart: Spacing.L * 1.5,
  cursor: 'pointer',
}

const linkDiv: CSSObject = {
  color: Color.light.Text.InvertedDefault,
}

const card: CSSObject = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  inlineSize: '100%',
  cursor: 'pointer',
}

const header: CSSObject = {
  inlineSize: `calc(100% - ${Spacing.M * 6.25}px)`,
  maxInlineSize: Spacing.M * 50,
}

export const styles = {
  card,
  linkDiv,
  button,
  header,
}
